import { PlusOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Table, Select, Input, PopConfirm } from '@maxtropy/components';
import { apiV2DeviceAllPost } from '@maxtropy/device-customer-apis-v2';
import { v4 as uuidv4 } from 'uuid';
import type { HighColumnsProp } from '../ElectricMapConfig';
interface Option {
  label: string | undefined;
  value: number | undefined;
}
interface DeviceListType {
  id?: number;
  deviceId?: number;
  deviceAliaName?: string;
}
interface Props {
  open: boolean;
  setOpen: (v: boolean) => void;
  deviceList?: HighColumnsProp['deviceList'];
  onSave: (updatedData: HighColumnsProp['deviceList']) => void; // 回传修改后的数据
}
const HeighMoudal: React.FC<Props> = ({ open, setOpen, deviceList, onSave }) => {
  const [form] = Form.useForm();
  const [deviceOp, setDeviceOp] = useState<Option[] | undefined>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      setLoading(true);
      apiV2DeviceAllPost({})
        .then(res => {
          const dataRes = res.list;
          const options = dataRes?.map(i => ({
            label: i.name,
            value: i.id,
          }));
          setDeviceOp(options);
          form.setFieldsValue({ deviceList: deviceList });
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [open, form]);

  const columns = [
    {
      title: '设备',
      dataIndex: 'deviceId',
      render: (_: any, record: DeviceListType, index: number) => {
        return (
          <Form.Item
            rules={[{ message: '请选择', required: true }]}
            name={['deviceList', index, 'deviceId']}
            style={{ marginBottom: '0px' }}
          >
            <Select
              style={{ width: '288px' }}
              placeholder="请选择"
              options={deviceOp}
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>
        );
      },
    },
    {
      title: '展示名称',
      width: 250,
      dataIndex: 'deviceAliaName',
      render(_: any, record: DeviceListType, index: number) {
        return (
          <Form.Item
            name={['deviceList', index, 'deviceAliaName']}
            style={{ marginBottom: 0 }}
            rules={[
              { message: '请选择展示名称', required: true },
              { max: 50, message: '最多输入50个字符' }, // 添加字符长度限制
            ]}
          >
            <Input placeholder="请输入" maxLength={50} />
          </Form.Item>
        );
      },
    },
    {
      title: '操作',
      dataIndex: 'option',
      width: 120,
      render: (_: any, record: DeviceListType) => {
        return (
          <PopConfirm
            title="您是否删除？"
            onConfirm={() => {
              const tableData = form.getFieldValue('deviceList');
              const newData = tableData.filter((e: DeviceListType) => e.id !== record.id);
              form.setFieldsValue({ deviceList: [...newData] });
            }}
          >
            <Button type="link">删除</Button>
          </PopConfirm>
        );
      },
    },
  ];

  const addRow = () => {
    const tableData = form.getFieldValue('deviceList') || [];
    const newRow = {
      id: uuidv4(),
      new: true,
      deviceId: '',
      deviceAliaName: '',
    };
    form.setFieldsValue({ deviceList: [...tableData, newRow] });
  };

  const handleOk = async () => {
    const values = await form.validateFields();
    if (values) {
      const res = form.getFieldValue('deviceList');
      const newres = res.map((item: any, index: number) => {
        const id = item.new ? undefined : item.id;
        return {
          ...item,
          id: id,
        };
      });

      onSave(newres);
      setOpen(false);
    }
  };
  return (
    <Modal
      title="高能耗点"
      size="large"
      open={open}
      onOk={handleOk}
      okText="确认"
      onCancel={() => {
        setOpen(false);
        form.resetFields();
      }}
    >
      <div>
        <Form form={form} className="table-form" isOrigin initialValues={{ deviceList: [] }}>
          <Button
            wrapStyle={{ width: '100%' }}
            style={{ width: '100%' }}
            type="dashed"
            onClick={addRow}
            ghost
            icon={<PlusOutlined />}
          >
            新建
          </Button>
          <Form.Item noStyle labelAlign="left" name="deviceList" valuePropName="dataSource">
            <Table loading={loading} columns={columns} rowKey="id" />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default HeighMoudal;
